import { configureStore } from '@reduxjs/toolkit';
import { classActionMiddleware } from '@/store/_setup/classActionMiddleware';
import { listApi } from '@/api/listApi';
import { notificationsApi } from '@/api/notificationsApi';

import { designerReducer } from '@/store/designer/designerReducer';
import { listReducer } from '@/store/lists/listReducer';
import { notificationsReducer } from '@/store/notifications/reducer/notificationsReducer';
import { userReducer } from '@/store/user/reducer/userReducer';
import { discussionsReducer } from '@/features/discussions/discussionsSlice';
import { themeReducer } from '@/features/theme';

export const store = configureStore({
  reducer: {
    designer: designerReducer,
    user: userReducer,
    notifications: notificationsReducer,
    lists: listReducer,
    discussions: discussionsReducer,
    theme: themeReducer,
    [listApi.reducerPath]: listApi.reducer,
    [notificationsApi.reducerPath]: notificationsApi.reducer
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware().concat(classActionMiddleware, listApi.middleware, notificationsApi.middleware),
  devTools: process.env.NODE_ENV !== 'production'
});

export type AppStore = typeof store;
export type RootState = ReturnType<AppStore['getState']>;
export type AppDispatch = AppStore['dispatch'];
